import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';

var RichTextEditorTinyMCE = function RichTextEditorTinyMCE(_ref) {
  var value = _ref.value,
      onEditorChange = _ref.onEditorChange;
  var editorRef = useRef(null);
  return /*#__PURE__*/React.createElement(Editor, {
    tinymceScriptSrc: "https://admin-live.artbasel.com/static/tinymce/js/tinymce/tinymce.min.js",
    onInit: function onInit(evt, editor) {
      var element = editor.getContainer().querySelector('button.tox-statusbar__wordcount');
      element.click();
      editorRef.current = editor;
    },
    value: value,
    onEditorChange: onEditorChange,
    init: {
      height: 500,
      menubar: false,
      toolbar_mode: 'wrap',
      toolbar: 'code |' + 'bold italic |' + 'numlist bullist |',
      plugins: ['lists', 'link', 'advlist', 'code', 'table', 'wordcount'],
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
    }
  });
};
/*
 * PropType validation
 */


RichTextEditorTinyMCE.propTypes = {
  value: PropTypes.string,
  onEditorChange: PropTypes.func
};
export default RichTextEditorTinyMCE;